const styles = {
  "nav-bar": "_nav-bar_z70g4_8",
  "nav-bar-items": "_nav-bar-items_z70g4_14",
  "nav-tab": "_nav-tab_z70g4_25",
  "nav-item": "_nav-item_z70g4_47"
};
export {
  styles as default
};
//# sourceMappingURL=Nav.module.css.js.map
